<template>
    <tr>
        <td v-if="!isSalesStaff">
            <button class="button is-primary" @click="saveInlandPrice()">
                <i class="fas fa-save"></i>
            </button>
        </td>
        <td>
            #
        </td>
        <td>
            <input class="input is-small" v-model="lot_start" placeholder="Lot start #"/>
        </td>
        <td>
            <input class="input is-small" v-model="lot_end" placeholder="Until lot #"/>
        </td>
        <td>
            <input class="input is-small" v-model="auction" placeholder="Auction Name"/>
        </td>
        <td v-if="!isSalesStaff">
            <input class="input is-small" v-model="yokohama" placeholder="Delivery to Yokohama"/>
        </td>
        <td>
            <input class="input is-small" v-model="yokohama_sales" placeholder="Delivery to Yokohama"/>
        </td>
        <td v-if="!isSalesStaff">
            <input class="input is-small" v-model="osaka" placeholder="Delivery to Nagoya"/>
        </td>
        <td>
            <input class="input is-small" v-model="osaka_sales" placeholder="Delivery to Nagoya"/>
        </td>
        <td v-if="!isSalesStaff">
            <input class="input is-small" v-model="nagoya" placeholder="Delivery to Nagoya"/>
        </td>
        <td>
            <input class="input is-small" v-model="nagoya_sales" placeholder="Delivery to Nagoya"/>
        </td>
        <td v-if="!isSalesStaff">
            <input class="input is-small" v-model="kobe" placeholder="Delivery to Kobe"/>
        </td>
        <td>
            <input class="input is-small" v-model="kobe_sales" placeholder="Delivery to Kobe"/>
        </td>
        <td v-if="!isSalesStaff">
            <input class="input is-small" v-model="hakata" placeholder="Delivery to Hakata"/>
        </td>
        <td>
            <input class="input is-small" v-model="hakata_sales" placeholder="Delivery to Hakata"/>
        </td>
        <td>
            <select v-model="company" @change="changeCompany($event)" class="select">
                <option v-for="(company, index) in companies" :value="index">{{ company.name }}</option>
            </select>
        </td>
        <td>
            <input class="input is-small" v-model="comment" placeholder="Comment"/>
        </td>
    </tr>
</template>

<script>
    export default {
        methods: {
            saveInlandPrice() {
                this.$store.dispatch('storeNewInlandPrice')
            },
            changeCompany(event) {
                let id = event.target.value
                this.auction = this.companies[id].auction
                this.yokohama = this.companies[id].yokohama
                this.yokohama_sales = this.companies[id].yokohama_sales
                this.nagoya = this.companies[id].nagoya
                this.nagoya_sales = this.companies[id].nagoya_sales
                this.kobe = this.companies[id].kobe
                this.kobe_sales = this.companies[id].kobe_sales
                this.hakata = this.companies[id].hakata
                this.hakata_sales = this.companies[id].hakata_sales
            }
        },
        computed: {
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            },
            lot_start: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.lot_start
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'lot_start', value: value})
                }
            },
            lot_end: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.lot_end
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'lot_end', value: value})
                }
            },
            auction: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.auction
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'auction', value: value})
                }
            },
            yokohama: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.yokohama
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'yokohama', value: value})
                }
            },
            yokohama_sales: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.yokohama_sales
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'yokohama_sales', value: value})
                }
            },
            nagoya: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.nagoya
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'nagoya', value: value})
                }
            },
            nagoya_sales: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.nagoya_sales
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'nagoya_sales', value: value})
                }
            },
            osaka: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.osaka
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'osaka', value: value})
                }
            },
            osaka_sales: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.osaka_sales
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'osaka_sales', value: value})
                }
            },
            kobe: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.kobe
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'kobe', value: value})
                }
            },
            kobe_sales: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.kobe_sales
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'kobe_sales', value: value})
                }
            },
            hakata: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.hakata
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'hakata', value: value})
                }
            },
            hakata_sales: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.hakata_sales
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'hakata_sales', value: value})
                }
            },
            company: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.company
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'company', value: value})
                }
            },
            comment: {
                get() {
                    return this.$store.getters.getNewInlandPricePlan.comment
                },
                set(value) {
                    this.$store.dispatch('setNewInlandPriceFieldValue', {field: 'comment', value: value})
                }
            },
            companies () {
                return this.$store.getters.getInlandCompanies
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 10px;
        font-weight: bold;
        background-color: whitesmoke;
    }
    .is-responsive-table td {
        font-size: 10px;
    }
    .image {
        max-height: 32px;
        height: 32px;
        padding-left: 2px;
    }
    .is-automatic {
        background-color: rgba(0, 255, 255, 0.25);
    }
    .is-real {
        background-color: rgba(255, 255, 0, 0.27);
    }
    .is-win {

    }
    .is-canceled {

    }
    .nowrap {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .is-responsive-table table {
        width: 100%;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/InlandPrices/InlandPriceCreateTableRow.vue